import type { Instant, LocalDate } from '@js-joda/core';
import type { InstitutionalHolderStatus } from '@thinkalpha/quant-ws-client/contracts/institutional-holders.js';

export type HoldersPeriodId = 'latest';
export type HolderFilter = 'all' | Exclude<InstitutionalHolderStatus, 'new' | 'closed'>;
export type HolderSortColumn =
    | 'rank'
    | 'holder'
    | 'shares'
    | 'value'
    | 'ownershipPct'
    | 'floatPct'
    | 'changeShares'
    | 'changePct';
export type SortDirection = 'asc' | 'desc';

export interface InstitutionalHolderPeriod {
    id: HoldersPeriodId;
    label: string;
    asOfDate: LocalDate | null;
}

export interface InstitutionalHolderRow {
    id: string;
    rank: number;
    name: string;
    shares: number;
    valueUsd: number | null;
    ownershipPct: number;
    floatPct: number;
    changeShares: number;
    changePct: number;
    status: InstitutionalHolderStatus;
}

export interface InstitutionalHoldersSummary {
    institutionalOwnershipPct: number;
    totalHolders: number;
    newPositions: number;
    netChange: number;
    closedPositions: number;
    asOfDate: LocalDate | null;
    updatedAt: Instant | null;
    hasDiff: boolean;
}

export interface InstitutionalHoldersSummaryView extends InstitutionalHoldersSummary {
    institutionalOwnershipFormatted: string;
    totalHoldersFormatted: string;
    newPositionsFormatted: string;
    netChangeFormatted: string;
    closedPositionsFormatted: string;
    asOfFormatted: string;
    updatedAtFormatted: string;
}

export interface InstitutionalHolderViewRow extends InstitutionalHolderRow {
    sharesFormatted: string;
    valueFormatted: string;
    ownershipFormatted: string;
    floatPctFormatted: string;
    ownershipBarPct: number;
    changeFormatted: string;
    changePctFormatted: string;
    statusLabel: string;
    changeDirection: 'up' | 'down' | 'flat';
}

export interface HoldersState {
    periodId: HoldersPeriodId;
    filter: HolderFilter;
    search: string;
    sortColumn: HolderSortColumn;
    sortDirection: SortDirection;
}

export function createInitialHoldersState(): HoldersState {
    return {
        periodId: 'latest',
        filter: 'all',
        search: '',
        sortColumn: 'shares',
        sortDirection: 'desc',
    };
}
